$(document).ready(function() {
  // $('.slick-products').slick({
  //   arrows: false,
  //   dots: true
  // });
  
  // let cI = $('.slick-products').slick('slickCurrentSlide');
  // $('.slick-products').slick('slickGoTo', cI);
  
  let nudgeUrl = 'https://us-central1-takeout-order.cloudfunctions.net/app/nudges?endpoint=orders';
  let prodUrl = 'https://us-central1-takeout-order.cloudfunctions.net/app/product?id=';
  let nudges, nudge, showNudge;

  let n = 0;
  let	x = Math.floor(Math.random() * 50) + 1;
  let stop;

  let path = window.location.pathname;
  let search = window.location.search;
  
  if( search.includes('customer_posted=true') || search.includes('newsletter') ){
  	document.getElementById('footer').scrollIntoView();
  };
  
  if(path.includes('challenge')){
    window.scrollTo(0, 0);
    $('.email-signup').addClass('d-none');
  }

  if(path.includes('cart')){
    getCart();
  }

  $('.sub-head').click(function(e){
    e.preventDefault();
    $('.has-sub').toggleClass('open');
  })
  
  var links = document.links;
  for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
    if (links[i].hostname !== window.location.hostname) {
      links[i].target = '_blank';
      links[i].rel = 'noreferrer noopener';
    }
  }
  
  function onlySpaces(str) {
    return str.trim().length === 0;
  }
  
  function delay(callback, ms) {
    var timer = 0;
    return function() {
      var context = this, args = arguments;
      clearTimeout(timer);
      timer = setTimeout(function () {
        callback.apply(context, args);
      }, ms || 0);
    };
  }

  $('.searchBtn').click(function(e){
  	e.preventDefault();
    if($('body').hasClass('searchOpen')){
      clearSearch()
    }
    
    $('body').toggleClass('searchOpen');
    $('body').removeClass('cartOpen');
    $('body').removeClass('open');
    $('header').removeClass('hides');
    $('.searchOpen #mobileSearchForm .searchQuery').focus();

  });
  
  function clearSearch(){
    $('.searchQuery').val('');
    $('#searchResults').addClass('d-none'); 
    $('.page-container').removeClass('d-none'); 
    $('#searchResults .items').html('');
    searchResults = false;
  }
  
  $('#searchClose').click(function(e){
    clearSearch()
  });

  $('#mobileSearchForm').submit(function(e){
    e.preventDefault();
  });

  $('#searchForm').submit(function(e){
    e.preventDefault();
  });

  let searchResults;
  
  $('.searchQuery').keyup(delay(function(e){
    
    let q = $(this).val();
    let limit = 10;

    if(!q || onlySpaces(q) ){
      clearSearch()
      return;
    }
    
    let query = '/search/suggest.json?q='+q+'*&resources[type]=product&resources[limit]='+limit+'&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,tag,vendor';
    
    fetch(query)
    .then(res => res.json())
    .then(
      (result) => {
        let results = result.resources.results.products;
        searchResults = true;
        $('#searchResults .items').html('');
        $('#searchResults').removeClass('d-none');
        $('.page-container').addClass('d-none'); 
        window.scrollTo(0, 0);

        if(results.length > 0){
          $('#searchTitle').html(results.length + ' results for '+ q);

          for(let i = 0 ; i < results.length; i++){
            let result = results[i];
            let lowimage = result.image.replace('.png', '_50x50@2x.png');
            let hiimage = result.image.replace('.png', '_530x530@2x.png');

            let item = `<div class="col-6 col-lg-4 col-xl-3 mb-3">
                          <div class="search-view-item">
                            <a class="grid-view-item__link" href="${result.url}">
                              <img class="grid-view-item__image image-1 lazyload" width="100%" src="${lowimage}" data-src="${hiimage}" alt="${result.title}">
                              <div class="grid-view-item__title">${result.title}</div>
                              <div class="grid-view-item__meta">${result.price}</div>
                            </a>
                          </div>
                        </div>`
             $('#searchResults .items').append(item);
          }
        }else{
          $('#searchTitle').html('Nothing To See');
          searchResults = true;
        }
        
        lazyload();
        
      },
      (error) => {
        console.log(error);
      }
    );
  }, 500));

  function playNudges(){ 

    let playNudge = function(){
      jQuery.get(prodUrl+nudges[x].product_id, function(pres){
        nudges[x].product = pres.product;
        nudge = nudges[x];
        showNudge = true;

        jQuery('#nudge-url').attr('href', 'https://takeoutorder.co/products/'+nudge.product.handle);
        jQuery('#nudge-customer').text(nudge.name);
        if(nudge.province_code){
          jQuery('#nudge-city').text(nudge.city +', '+ nudge.province_code);
        }else{
          jQuery('#nudge-city').text(nudge.city);
        }
        jQuery('#nudge-title').text(nudge.product.title);
        jQuery('#nudge-time').text(nudge.timeago);

        let imgsrc = (nudge.product.image.src).split('.png');
        let img = imgsrc[0] + '_75x75@2x.png'+ imgsrc[1]; 

        jQuery('#nudge-product figure').css("background-image", "url(" + img + ")");
        jQuery('#nudge-wrapper').addClass('show');


        setTimeout(function(){
          showNudge = false;
          jQuery('#nudge-wrapper').removeClass('show');
        }, 10000);
      });
    }

    setTimeout(function(){
      playNudge();

      stop = setInterval(function() {
        if(n < 15){
          n++;
          x = Math.floor(Math.random() * 50) + 1;

          playNudge();
        }else{
          //n = 0;
          clearInterval(stop);
          stop = undefined;
          showNudge = false;
          jQuery('#nudge-wrapper').removeClass('show');
        }
      }, 20000);

    }, 3000);
  }

  jQuery.get(nudgeUrl, function(res){

    function after(){
      if(ng >= res.length){
        nudges = res;
        //playNudges();
      }
    }

    let ng = 0;
    jQuery.each(res, function(r){
      res[r].timeago = moment(res[r].created_at).fromNow();
      ng++;
      after();
    });
  });
    
  
  let winW = $(window).width();
  
  let getwinW = function(){
    let winW = $(window).width();
    
    if(winW < 992){
      return true;
    }else{
      return false; 
    }
  }
  
  if (getwinW) {
    
    $('#mobile-bars').click(function(e){
      e.stopPropagation();
      let currentScrollPos = $(window).scrollTop();
      $('body').toggleClass('open');
      if(!searchResults){
        $('#mobileSearchForm .searchQuery').blur();
        $('body').removeClass('searchOpen');
      }
      
      if( $('body').hasClass('open') && currentScrollPos == 0){
        $('.page-container').addClass('padTop');
      }else{
        $('.page-container').removeClass('padTop');
      }
      
      $('body').removeClass('cartOpen');
      
    });

    $('.page-container').click(function(e){
      //if not mobile menu background
      let noRedirect = '.no-click';
      if (!e.target.matches(noRedirect)) {
        if( $('body').hasClass('cartOpen') ){
          e.preventDefault();
          $('body').toggleClass('cartOpen');
        }
      }
      
    });
    
    let prevScrollpos = $(window).scrollTop();
    let currentScrollPos;
    let hidePos = -($('header').height());
        
    $(window).scroll(function(){
      currentScrollPos = $(window).scrollTop();
      let scrollRange = currentScrollPos - prevScrollpos;     
      let topPos = $('header').position().top;
      
      if( !$('body').hasClass('open') && !$('body').hasClass('cartOpen') ){  
        
        if (prevScrollpos > currentScrollPos || currentScrollPos <= 0) {
          if(scrollRange < -33 || currentScrollPos <= 0){
            $('body').addClass('fixedHeader');
          }
        } else if(prevScrollpos < currentScrollPos && scrollRange > 33) {
          $('body').removeClass('fixedHeader');
          setTimeout(() => {
              if(!searchResults){
                $('#mobileSearchForm .searchQuery').blur();
                $('body').removeClass('searchOpen');
              }
          }, 250);
          //let nextPos = topPos - Math.abs(scrollRange);
          //topPos = nextPos < hidePos ? hidePos : nextPos;
          //$('header').css({'transform' : 'translateY('+topPos+'px)'});
        }
        
         if(currentScrollPos <= 0){
           $('body').removeClass('fixedHeader');
         }
        
        prevScrollpos = currentScrollPos;
      }
    });
    
    
  }

  $('.swatch :radio').change(function() {
    let pid = $(this).attr('data-pid');
    let optionIndex = $('.'+ pid).attr('data-option-index');
    //let optionIndex = $(this).closest('.swatch').attr('data-option-index');
    let optionValue = $(this).val();
    let sel = $('.sel-'+pid);
    console.log(optionValue);
    
    $(sel)
      .eq(optionIndex)
      .val(optionValue)
      .trigger('change');

    // $(this)
    //   .closest('form')
    //   .find('.single-option-selector')
    //   .eq(optionIndex)
    //   .val(optionValue)
    //   .trigger('change');   
  });
  
  var _config = {
    // What you might want to change
    addToCartBtnLabel:             'Add to bag',
    addedToCartBtnLabel:           'Thank you!',
    addingToCartBtnLabel:          'Adding...',
    soldOutBtnLabel:               'Sold Out',
    howLongTillBtnReturnsToNormal: 500, // in milliseconds.
    //cartCountSelector:             '.cart-count, #cart-count a:first, #gocart p a, #cart .checkout em, .item-count',
    cartCountSelector: '.cart-num, .cart-num-sm',
    cartTotalSelector:             '#cart-price',
    // 'aboveForm' for top of add to cart form, 
    // 'belowForm' for below the add to cart form, and 
    // 'nextButton' for next to add to cart button.
    feedbackPosition:              'nextButton',

    // What you will never need to change
    addToCartBtnSelector:          '[type="submit"]',
    addToCartFormSelector:         'form[action="/cart/add"]',
    shopifyAjaxAddURL:             '/cart/add.js',
    shopifyAjaxCartURL:            '/cart.js'
  };
  
  function getCart(){
    $('body').addClass('fixedHeader');
    let cartQuery = '/cart.js';

    fetch(cartQuery)
    .then(res => res.json())
    .then(
      (result) => {
        $('.loader-wrapper').removeClass('show');
        if(!searchResults){
          $('#mobileSearchForm .searchQuery').blur();
          $('body').removeClass('searchOpen');
        }
        let item_count = result.item_count;
        let items_subtotal_price = result.items_subtotal_price;
		let total_price = result.total_price;
        let items = result.items;
        
        if (_config.cartCountSelector && $(_config.cartCountSelector).length) {
            var value = $(_config.cartCountSelector).html() || '0';
            $(_config.cartCountSelector).html(value.replace(/[0-9]+/,item_count)).removeClass('hidden-count');
          }
        
        if(items.length === 0){
          	$('.cart-empty').removeClass('d-none');
          	$('.cart-wrapper').addClass('d-none');
			return;
        }

        gtag('event', 'conversion', {
            'send_to': 'AW-668944371/KGANCKP6gpIYEPOP_b4C',
            'value': total_price/100,
            'currency': 'USD'
        });

        
        $('.cart-empty').addClass('d-none');
        $('.cart-wrapper').removeClass('d-none');
		$('.cart-items').html('');
        $('.cart-subtotal').html( '$'+(items_subtotal_price/100).toFixed(2) );
        
        for(let i = 0 ; i < items.length; i++){
        	let item = items[i];
          	let qty = item.quantity > 1 ? '('+item.quantity+')' : '';
          	let price = '$'+(item.price /100).toFixed(2);
          	let lowimage = item.image.replace('.png', '_25x25@2x.png');
          	let hiimage = item.image.replace('.png', '_150x150@2x.png');
            let size = item.variant_title ? '<p class="item-size">Size: '+item.variant_title+'</p>' : '';
          	
          	let lineItem = `<li class="cart-item">
							<a href="${item.url}" class="item-thumbnail"><img class="lazyload" width="100%" src="${lowimage}" data-src="${hiimage}" alt="${item.title}"></a>
                            <div class="item-details">
                              <div class="title-price">
                                  <a href="${item.url}" class="item-title">${item.title.split('-')[0]} <span class="qty">${qty}</span></a>
								  <span>${price} <a href="#" class="delete-item" data-line="${i+1}"><i class="fa-solid fa-trash-can"></i></a></span>
                              </div>
							  ${size}
                              <input class="item-qty mt-2" type="number" name="updates[]" value="${item.quantity}" min="0" pattern="[0-9]*"id="input-${i+1}">
                            </div>
                          </li>`
            $('.cart-items').append(lineItem);
        }

        let cartTotal = items_subtotal_price/100;

        if(cartTotal < 60){
          $('.cart-free-shipping').removeClass('d-none');
        }else{
          $('.cart-free-shipping').addClass('d-none');
        }
        
        lazyload();
        
      },
      (error) => {
        console.log(error);
      }); 
  }
  
  $('.close-cart').click(function(e){
    e.preventDefault();
    $('body').removeClass('cartOpen');
  });
  
  $('.cartBtn').click(function(e){
  	e.preventDefault();
    getCart();
    $('body').toggleClass('cartOpen');
    $('body').removeClass('open');
  });

  
  
  function cartChange(data){
   $('.loader-wrapper').addClass('show');
   $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: data,
      dataType: 'json', 
      success: function (data) { 
		getCart();
        
       }
    }); 
  }
  
  $('.cart-items').on('click', '.delete-item', function(e){
    e.preventDefault();
  	let line = $(this).data('line');
    let data = {'line': line,'quantity': 0};
    
    cartChange(data);
    
  });
  
  $('.cart-items').on('change', '.item-qty', function(e){
    let line = ( $(this).attr('id') ).replace('input-', '');
    let qty = $(this).val();
    let data = {'line': line, 'quantity': qty};
    
    cartChange(data);
  });
  
  let _showFeedback = function(success, html, $addToCartForm) {
      $('.ajaxified-cart-feedback').remove();
      var feedback = '<p class="ajaxified-cart-feedback ' + success + '">' + html + '</p>';
      switch (_config.feedbackPosition) {
        case 'aboveForm':
          $addToCartForm.before(feedback);
          break;
        case 'belowForm':
          $addToCartForm.after(feedback);
          break;
        case 'nextButton':
        default:
          $addToCartForm.find(_config.addToCartBtnSelector).after(feedback);
          break;   
      }
      // If you use animate.css
      // $('.ajaxified-cart-feedback').addClass('animated bounceInDown');
      $('.ajaxified-cart-feedback').slideDown();
    };
  
  let _setText = function($button, label) {
    if ($button.children().length) {
      $button.children().each(function() {
        if ($.trim($(this).text()) !== '') {
          $(this).text(label);
        }
      });
    }
    else {
      $button.val(label).text(label);
    }
  };
  
  $(_config.addToCartFormSelector).submit(function(e) {
  	e.preventDefault();
    let $addToCartForm = $(this);
    let $addToCartBtn = $addToCartForm.find(_config.addToCartBtnSelector);
      
    _setText($addToCartBtn, _config.addingToCartBtnLabel);
    $addToCartBtn.prop('disabled', true);

    $.ajax({
      url: _config.shopifyAjaxAddURL,
      dataType: 'json',
      type: 'post',
      data: $addToCartForm.serialize(),
      success: function(itemData) {
        // Re-enable add to cart button.
        $addToCartBtn.addClass('disabled');
        _setText($addToCartBtn, _config.addedToCartBtnLabel);
        
    	$('body').addClass('cartOpen');
        $('header').removeClass('hides');
        
        getCart();
        
        //_showFeedback('success','<i class="fa fa-check"></i> Added! <a href="/cart">View Bag</a> or <a href="/collections/all">Continue Shopping</a>.',$addToCartForm);
        window.setTimeout(function(){
          $addToCartBtn.prop('disabled', false).removeClass('disabled');
          _setText($addToCartBtn,_config.addToCartBtnLabel);
        }, _config.howLongTillBtnReturnsToNormal);

        // Update cart count and show cart link.
        $.getJSON(_config.shopifyAjaxCartURL, function(cart) {
          if (_config.cartCountSelector && $(_config.cartCountSelector).length) {
            var value = $(_config.cartCountSelector).html() || '0';
            $(_config.cartCountSelector).html(value.replace(/[0-9]+/,cart.item_count)).removeClass('hidden-count');
          }
        });        
      }, 
      error: function(XMLHttpRequest) {
        let response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;
        if (response.slice(0,4) === 'All ') {
          _showFeedback('error', response.replace('All 1 ', 'All '), $addToCartForm);
          $addToCartBtn.prop('disabled', false);
          _setText($addToCartBtn, _config.soldOutBtnLabel);
          $addToCartBtn.prop('disabled',true);
        }
        else {
          _showFeedback('error', '<i class="fa fa-warning"></i> ' + response, $addToCartForm);
          $addToCartBtn.prop('disabled', false).removeClass('disabled');
          _setText($addToCartBtn, _config.addToCartBtnLabel);
        }
      }
    });   
    return false;
  });
  
  lazyload();

});

//   let texts, text, showText;
//   let textPlayed = sessionStorage.getItem("textPlayed");
  
//   function removeTexts (){
//     showText = false;
//     jQuery('#text-wrapper').removeClass('show');
//   }
  
//   function playTexts (){
//     let playText = function(){
//         showText = true;
//         jQuery('#text-wrapper').addClass('show');
//       	sessionStorage.setItem("textPlayed", true);

//         setTimeout(function(){
//           showText = false;
//           jQuery('#text-wrapper').removeClass('show');
//         }, 10000);
//     }

//     setTimeout(function(){
//       playText();
    
//       setTimeout(function(){
//         removeTexts();
//       }, 10000);

//     }, 2500);
//   }
  
//   if(!textPlayed){
//   	playTexts();
//   }
  
//   document.getElementById('#text-wrapper').click(function(){
//     removeTexts();
//   });
